import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {UserRole} from '@emma-labs/shared/typescript';
import {Observable, of} from 'rxjs';
import {first, map} from 'rxjs/operators';
import {AgentSession} from './entities/agent-session';
import {AuthService} from './services/auth.service';

export const DashboardGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const authService = inject(AuthService);

  /*
  Angular does not let us redirect from a parent (Dashboard) to a child. Everytime, the guards attached to the parent
  will run. So, to prevent an infinite loop, we can simply return true when accessing a page that is part of the parent's
  children.
   */
  const rootPath = route.routeConfig?.path;
  const childrenPath = route.routeConfig?.children?.flatMap((c) => c.path?.split('/'));
  const url = state.url.split('/');
  url.shift(); // We remove the first '/'
  if (url[0] === rootPath && childrenPath?.includes(url[1])) {
    return of(true);
  }

  return authService.currentAgentSessionOrAuthError.pipe(
    first(),
    map((session: AgentSession) => {
      switch (session.agent.role) {
        case UserRole.UNDERWRITER:
        case UserRole.CASE_MANAGER:
          return router.parseUrl('/dashboard/underwriting');
        default:
          return router.parseUrl('/dashboard/proposals');
      }
    }),
  );
};
